import { Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function StoryCta({ className = "" }) {
  return (
    <div className={`flex flex-col items-start gap-3 ${className}`} data-testid="story-cta">
      <a href={SITE.phoneHref} className="btn-emergency whitespace-nowrap" data-testid="story-cta-call-btn">
        <Phone className="w-4 h-4" /> Emergency now? Call 24/7
      </a>
      <span className="display-chunky text-xl text-white/80">{SITE.phone}</span>
    </div>
  );
}
